import React, { useEffect, useRef } from 'react';
import Modal from '@payscale/design/lib/modal';
import './LoggedOut.scss';
export default function LoggedOut() {
    const modalRef = useRef(null);
    useEffect(() => {
        if (modalRef && modalRef.current) {
            modalRef.current.show();
        }
        return () => {
            if (modalRef && modalRef.current) {
                modalRef.current.hide();
            }
        };
    }, []);
    return (React.createElement(Modal, { className: 'logout--logout-modal', id: 'logout-modal', allowClose: false, show: true, ref: modalRef, displayCloseButton: false },
        React.createElement("iframe", { id: "loginModal", src: "/home", width: "800", height: "600", frameBorder: "0", seamless: true })));
}
